import { render, staticRenderFns } from "./MeasurementItem.vue?vue&type=template&id=e69a8238&scoped=true&"
import script from "./MeasurementItem.vue?vue&type=script&lang=js&"
export * from "./MeasurementItem.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementItem.vue?vue&type=style&index=0&id=e69a8238&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69a8238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VFlex,VIcon,VSpacer})
